var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 2.19515L1.725 0.0951457C1.4625 -0.0798543 1.1125 0.00764573 0.85 0.182646C0.675 0.357646 0.5 0.620146 0.5 0.882646V10.5076C0.5 10.8576 0.675 11.2076 1.025 11.2951L6.625 13.7451V2.19515Z",
    fill: "#080B11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 0.182328C13.8875 0.00732826 13.625 0.00732826 13.3625 0.0948283L8.375 2.19483V13.7448L13.975 11.3823C14.325 11.2073 14.5 10.9448 14.5 10.5948V0.882328C14.5 0.619828 14.325 0.357328 14.15 0.182328Z",
    fill: "#080B11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.ea765c5e0579c3cc300707cbe7c7ce01.svg";
export { ForwardRef as ReactComponent };